<script>
  import Form from './../../../../helpers/form';
  import modal from './../../../../services/modal';

  export default {
    props: {
      routeSave: {
        type: String,
        required: true
      },

      routeAfterSaving: {
        type: String,
        required: true
      },

      emptyEmail: {
        type: Boolean,
        required: true
      },

      needAgencyApprove: {
        type: Boolean,
        required: true
      },

      post: {
        type: Object,
        required: false,
        default() {
          return {};
        }
      },

      editMode: {
        type: Boolean,
        required: false,
        default() {
          return false;
        }
      },
    },

    data() {
      return {
        form: new Form({
          image: '',
          image_crop: '',
          image_crop_extension: '',
          image_backup: '',
          file_id: '',
          save: '',
          entity_type: 'news',
          title: '',
          email: '',
          category_id: 1,
          images_blocks: {},

          ...this.post
        })
      };
    },

    methods: {
      saveDraft() {
        if(this.form.request) return;

        this.form.save = 'draft';

        this.prepareFormForRequest();

        this.submitForm();
      },

      saveDraftPreview() {
        if(this.form.request) return;

        this.form.save = 'draft_preview';

        this.prepareFormForRequest();

        this.submitForm();
      },

      submit() {
        if(this.form.request) return;

        this.form.save = 'to_checking';

        this.prepareFormForRequest();

        this.submitForm();
      },

      updatePostImagesBlocks(imagesBlocks) {
        this.form.errors.clear('images_blocks');

        this.form.images_blocks = {};

        imagesBlocks.forEach((imagesBlock) => {
          this.form.images_blocks[imagesBlock.id] = imagesBlock;
        });
      },

      prepareFormForRequest() {
        this.form.image_crop = this.$refs.imageCrop.value;
        this.form.image_crop_extension = this.$refs.imageCropExtension.value;
        this.form.image_backup = this.$refs.imageBackup.value;
        this.form.file_id = this.$refs.fileId.value;
        this.form.image = this.$refs.image.value;
      },

      submitForm() {
        this.$root.showMainLoadingBar = true;

        let method = this.editMode ? 'put' : 'post';

        this.form[method](this.routeSave)
          .then((response) => {
            this.$root.showMainLoadingBar = false;

            modal
              .success({text: `News post successfully ${this.editMode ? 'updated' : 'created'}.`})
              .then(() => {
                if(response.redirect) {
                  location.href = response.redirect;
                } else {
                  location.href = this.routeAfterSaving;
                }
              });
          })
          .catch(() => {
            this.$root.showMainLoadingBar = false;
          });
      }
    }
  }
</script>
